import { useCallback, useMemo, useState } from "react";
import { Card, CardContent } from "@altimateai/lego";
import { ConversationGroup } from "./context/types";
import Conversation from "./Conversation";
import ConversationHeader from "./ConversationHeader";
import ConversationReplyForm from "./ConversationReplyForm";
import classes from "../../details/styles.module.scss";
import ConversationHighlightText from "./ConversationHighlightText";
import { useConversationGroupContext } from "./context/ConversationsProvider";
import { DbtDocsShareDetails } from "../types";
import { Button } from "@altimateai/lego";

interface Props {
  conversationGroup: ConversationGroup;
  shareId: DbtDocsShareDetails["share_id"];
  onSelect: () => void;
}

const ConversationGroupComponent = ({
  conversationGroup,
  shareId,
  onSelect,
}: Props) => {
  const { users } = useConversationGroupContext();
  const user = useMemo(() => {
    if (!conversationGroup.owner) {
      return;
    }

    return users[conversationGroup.owner];
  }, [conversationGroup.owner, users]);

  // const codeblockLoaded = useConversationGroupSelector(
  //   (state) => state.codeblockLoaded
  // ) as boolean | undefined;

  const { isSelected } = useConversationGroupContext();
  const [showReplies, setShowReplies] = useState(false);

  const onRender = useCallback(
    (node: HTMLElement | null) => {
      if (!isSelected || !node) {
        return;
      }

      console.log(
        "ConversationGroupComponent scrolling",
        conversationGroup.conversation_group_id,
      );
      setTimeout(() => {
        (node as unknown as HTMLElement).scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        // adding this timeout of 500ms to wait for ConversationHighlighter to complete scrolling
      }, 1000);
    },
    [conversationGroup.conversation_group_id, isSelected],
  );

  if (
    !conversationGroup?.conversations?.length ||
    conversationGroup?.status !== "Pending"
  ) {
    return null;
  }

  const [first, ...rest] = conversationGroup.conversations;
  const replyButtonText = rest.length
    ? rest.length > 1
      ? `${rest.length} replies`
      : `${rest.length} reply`
    : "Reply";

  return (
    <div ref={onRender} className={classes.conversationGroup}>
      <Card className={`${isSelected ? "active" : ""}`} onClick={onSelect}>
        <ConversationHeader
          user={user}
          timestamp={first.timestamp}
          showResolveButton
          conversationGroupId={conversationGroup.conversation_group_id}
          shareId={shareId}
        />
        <CardContent>
          <ConversationHighlightText meta={conversationGroup.meta} />
          <p>{first.message.replace(/@\[(.*?)\]\((.*?)\)/g, "@$2")}</p>
          <Button
            onClick={() => setShowReplies((prev) => !prev)}
            variant="link"
          >
            {replyButtonText}
          </Button>
          {rest.length ? (
            <>
              {showReplies ? (
                <>
                  {rest.map((c) => (
                    <Conversation
                      key={c.conversation_id}
                      conversation={c}
                      shareId={shareId}
                    />
                  ))}
                </>
              ) : null}
            </>
          ) : null}
          {showReplies ? (
            <ConversationReplyForm
              conversationGroupId={conversationGroup.conversation_group_id}
              shareId={shareId}
            />
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
};

export default ConversationGroupComponent;
